/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_KooperationspartnerInputs */

const de__field_kooperationspartner = /** @type {(inputs: _Field_KooperationspartnerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kooperationspartner`)
};

/**

* @param {_Field_KooperationspartnerInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_kooperationspartner = /** @type {((inputs?: _Field_KooperationspartnerInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_KooperationspartnerInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_kooperationspartner(inputs)
});